var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-wifi",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20h.01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.82a15 15 0 0 1 20 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.859a10 10 0 0 1 14 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.429a5 5 0 0 1 7 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.363d8b7430f99c95ff696385c4bf7c23.svg";
export { ForwardRef as ReactComponent };